import { MENU_LOAD_START, MENU_LOAD_SUCCESS, MENU_LOAD_FAILURE } from './menuActions';

const initialState = {
  loading: false,
  data: [],
  error: null,
  lastFetchedAt: null,
};

export default function menuReducer(state = initialState, action) {
  switch (action.type) {
    case MENU_LOAD_START:
      return { ...state, loading: true, error: null };
    case MENU_LOAD_SUCCESS:
      return { ...state, loading: false, data: action.payload, lastFetchedAt: Date.now(), error: null };
    case MENU_LOAD_FAILURE:
      return { ...state, loading: false, error: action.error, data: [], lastFetchedAt: Date.now() };
    default:
      return state;
  }
}
